import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';

import NotificationAdministrationModal from 'src/components/superadmin/notifications/components/notification-administration-modal';
import composeModalActions from 'src/utils/modal-action-wrapper';
import NotificationAdministrationTable from 'src/components/superadmin/notifications/components/notification-administration-table';
import { Entities } from 'src/common';
import { IconLabel } from 'src/components/administration/IconLabel';

class NotificationAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
            selectedCompany: undefined,
        };
    }

    componentWillMount() {
        this.props.fetchAll(Entities.RECENT_OPERATOR_NOTIFICATIONS);
    }
    render() {
        const { t } = this.props;

        return (
            <div>
                <legend className="legend">{t('operator_notifications.admin.title')}</legend>
                <div className="row">
                    <div className="col-md-12">
                        <button
                            className="btn btn-xs btn-blue btn-flex pull-right"
                            onClick={() => {
                                this.props.openModal({
                                    component: NotificationAdministrationModal,
                                    componentProps: {
                                        isCreate: true,
                                        openModal: this.props.openModal,
                                    },
                                    title: t('user_functionality.create', {
                                        entity: t('operator_notifications.admin.title'),
                                    }),
                                    mandatoryFields: true,
                                });
                            }}>
                            <IconLabel icon="plus" text={t('operator_notifications.form.new_notification')} />
                        </button>
                    </div>
                </div>
                <div>
                    <div className="row">
                        <NotificationAdministrationTable notifications={this.props.notifications} t={t} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(NotificationAdministration));
